export default __webpack_public_path__ + "static/media/step4.faa2931e.png";